import React from 'react';
import * as S from './styles';
/**
 * Componente Divider do Design System OLX
 */
export const Divider = (props) => (React.createElement(S.DividerWrapper, Object.assign({ "data-ds-component": "DS-Divider" }, props)));
